export const homePageLinks = [
  {
    label: "How it works",
    href: "/#how-it-works",
  },
  {
    label: "For Voters",
    href: "/#voter",
  },
  {
    label: "For Builders",
    href: "/#builder",
  },
  {
    label: "Docs",
    href: "https://docs.uma.xyz/",
  },
  {
    label: "Blog",
    href: "https://blog.uma.xyz/",
  },
];

export const socialLinks = [
  {
    href: "http://discord.uma.xyz",
    icon: "discord",
    label: "Discord",
  },
  {
    href: "https://twitter.com/UMAprotocol",
    icon: "twitter-x",
    label: "Twitter",
  },
  {
    href: "http://discourse.uma.xyz",
    icon: "discourse",
    label: "Discourse",
  },
  {
    href: "https://github.com/UMAprotocol",
    icon: "github",
    label: "Github",
  },
];

export const footerLinks = {
  internal: [
    {
      label: "How it works",
      href: "#how-it-works",
    },
    {
      label: "For voters",
      href: "#voter",
    },
    {
      label: "For builders",
      href: "#builder",
    },
  ],
  external: [
    {
      label: "Explorer",
      href: "https://explorer.uma.xyz/",
    },
    {
      label: "Docs",
      href: "https://docs.uma.xyz/",
    },
    {
      label: "Stats",
      href: "https://stats.uma.xyz/",
    },
    {
      label: "Blog",
      href: "https://blog.uma.xyz/",
    },
  ],
};
